module.exports = __webpack_public_path__ + "static/img/bannerCO.28dbd75e.png";